import React from 'react';
import { IoInformationCircleOutline } from 'react-icons/io5';

function SaveVesselLabel(props) {
    const {
        value = "",
        onChange = () => { },
        placeholder = "Enter Voyage label",
        error = false,
    } = props;

    return (
        <div className="w-full py-1">
            <div className="mb-3 flex gap-2 border border-slate-200 bg-slate-50 p-2.5">
                <IoInformationCircleOutline className="mt-0.5 h-4 w-4 shrink-0 text-slate-600" aria-hidden="true" />
                <div className="min-w-0 text-xs leading-5 text-slate-700">
                    <div className="font-semibold text-slate-800">What will be saved</div>
                    <div>This vessel's calculated result and cargo plan. Other Matrix vessels are not included.</div>
                </div>
            </div>
            <label htmlFor="save-voyage-label" className="mb-1 block text-xs font-medium text-slate-700">
                Voyage label
            </label>
            <input
                id="save-voyage-label"
                type="text"
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                aria-invalid={error}
                aria-describedby="save-voyage-help"
                className={`w-full h-8 px-3 text-xs text-slate-800 border rounded-none outline-none focus:border-blue-600 transition-colors ${error ? 'border-rose-500' : 'border-slate-300'}`}
                autoFocus
            />
            <div id="save-voyage-help" className={`mt-1 text-xs ${error ? 'text-rose-600' : 'text-slate-500'}`}>
                {error ? 'Enter a voyage label to save.' : 'Find it in My Voyages. The saved estimate opens after saving.'}
            </div>
        </div>
    );
}

export default SaveVesselLabel;
